import { PureComponent } from 'react'
import Loader from '../Common/Loader'
import { Modal, Toast } from '@vzmi/shp_shared_compo'

export default class WithExport extends PureComponent {
  openExportModal = (content) => {
    const defaultContent = (
      <div className='text-center'>
        <Loader
          message={'匯出中...'}
          spinning
        />
      </div>
    )
    // show loading
    this.modal = Modal.info({
      'data-role': 'with-export-modal',
      width: 200,
      noIcon: true,
      noButtons: true,
      centered: true,
      content: content || defaultContent
    })
  }

  closeExportModal = ({ successMsg, errorMsg, isError } = {}) => {
    if (isError || errorMsg) {
      Toast.error(errorMsg || '匯出失敗')
    } else {
      Toast.info(successMsg || '匯出完成')
    }
    this.modal.destroy()
  }
}
